export default __webpack_public_path__ + "static/Important-Notice_EGTB_MY-713ddc1c15a672cffd6e91646ef5b5d1.pdf";